// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vertical-bar {
  border: 1px solid var(--color-gray01);
  height: 31px;
}
.search-label {
  display: flex;
  align-items: center;
}
.search-value {
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
.search-button {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.row-header {
  background-color: var(--color-gray01) !important;
}
.attachment-container {
  border: 1px solid var(--color-gray10);
  margin:0.2rem 0.8rem;
  padding: 0.6rem;
  width: auto;
}
.reply-attachment-container {
  background-color: white;
  border: 1px solid var(--color-gray10);
  padding: 10px;
  width: 100%;
}
textarea {
  resize: none !important;
}

div.ant-select.modifying {
  border: 5px solid red;
}
div.ant-space.modifying {
  border: 5px solid red;
}
td.ant-table-cell.moniter {
  background-color: #FFEFEF !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/element.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gDAAgD;AAClD;AACA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,aAAa;EACb,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".vertical-bar {\r\n  border: 1px solid var(--color-gray01);\r\n  height: 31px;\r\n}\r\n.search-label {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.search-value {\r\n  display: flex;\r\n  align-items: center;\r\n  /* justify-content: center; */\r\n}\r\n.search-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n.row-header {\r\n  background-color: var(--color-gray01) !important;\r\n}\r\n.attachment-container {\r\n  border: 1px solid var(--color-gray10);\r\n  margin:0.2rem 0.8rem;\r\n  padding: 0.6rem;\r\n  width: auto;\r\n}\r\n.reply-attachment-container {\r\n  background-color: white;\r\n  border: 1px solid var(--color-gray10);\r\n  padding: 10px;\r\n  width: 100%;\r\n}\r\ntextarea {\r\n  resize: none !important;\r\n}\r\n\r\ndiv.ant-select.modifying {\r\n  border: 5px solid red;\r\n}\r\ndiv.ant-space.modifying {\r\n  border: 5px solid red;\r\n}\r\ntd.ant-table-cell.moniter {\r\n  background-color: #FFEFEF !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
